export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/8e8641da5546a83267ff7cb844712535.svg";